// SplashScreen.js - Tıklama özelliği kaldırılmış versiyon
import React from "react";
import "./SplashScreen.css";

const SplashScreen = () => {
  return (
    <div className="splash-screen">
      <div className="logo-container">
        <div className="circles-container">
          <div className="splash-circle splash-circle-red"></div>
          <div className="splash-circle splash-circle-blue"></div>
          <div className="splash-circle splash-circle-yellow"></div>
        </div>
        <div className="main-text">
          <div className="bilim-text">BiLiM</div>
          <div className="konya-text">KONYA</div>
        </div>
        <div className="subtitle">
          <div className="subtitle-text">Personel Takip Sistemi</div>
        </div>
      </div>
    </div>
  );
};

export default SplashScreen;
